import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ContaReceberLoteVinculado {
  clienteId: number;
  nome: string;
  plano: string;
  valor: number;
}

export interface ContaReceberLotePrevia {
  clienteId: number;
  nome: string;
  documento: string;
  valorProprio: number;
  valorTotal: number;
  vinculados: ContaReceberLoteVinculado[];
}

export interface ContaReceberLoteRequest {
  segmentoId?: number | null;
  competencia: string;
  formaCobranca: string;
  contaCorrenteId?: number | null;
  descricao?: string | null;
  observacao?: string | null;
  clienteIds: number[];
}

export interface ContaReceberLoteResultado {
  gerados: number;
  erros: number;
  contasReceberIds: number[];
  mensagens: string[];
}

@Injectable({ providedIn: 'root' })
export class ContaReceberLoteService {

  private apiURL = environment.apiBaseUrl + 'autoshopping';

  constructor(private http: HttpClient) { }

  previa(segmentoId?: number | null, competencia?: string | null): Observable<ContaReceberLotePrevia[]> {
    let params = new HttpParams();
    if (segmentoId != null) {
      params = params.set('segmentoId', segmentoId.toString());
    }
    if (competencia) {
      params = params.set('competencia', competencia);
    }
    return this.http.get<ContaReceberLotePrevia[]>(`${this.apiURL}/previa`, { params });
  }

  gerar(request: ContaReceberLoteRequest): Observable<ContaReceberLoteResultado> {
    return this.http.post<ContaReceberLoteResultado>(`${this.apiURL}/gerar`, request);
  }
}
